const UIAuthorization = props => !!props.access && props.children;

export { UIAuthorization };
